import Dialog from "../../atoms/dialog";
import { Button, Grid, Box, Select, MenuItem, InputLabel, TextField, Typography, Checkbox, FormControlLabel } from "@material-ui/core";
import { useState, useEffect, Fragment } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getUserTriggersAndRrdefsOfAnEvent, getEvents } from '../../../store/constructs/events/selectors'
import { marginBottom } from "../../../config/styles";
import UpdateCancel from "../../atoms/buttons/UpdateCancel";
import { constructIds } from '../../../config/common';


const UpdateEventAlert = (props) => {

    const { onCompletion, eventId, showAlert, typesNotIn } = props;
    const [open, setOpen] = useState(true);
    const utsRrdefsHandlers = useSelector(getUserTriggersAndRrdefsOfAnEvent(eventId))
    const dependencies = [...utsRrdefsHandlers.userTriggers, ...utsRrdefsHandlers.rrdefs, ...utsRrdefsHandlers.handlers]
    const selectedEvent = useSelector(getEvents).find(item => item.id === eventId)

    const handleClose = () => {
        setOpen(false);
        showAlert(false);

    }

    return (
        <Dialog
            open={open}
            handleClose={handleClose}
        >

            <Box>

                <Grid xs={12} style={marginBottom}>

                    {dependencies.length > 0 && <Fragment>
                        <Typography> Updating the event can change the following entities </Typography>
                    </Fragment>}

                    <ol>
                        {dependencies.map((item, index) =>
                            <li key={index}>  {item.name ? item.name : selectedEvent.name}  ({constructIds.find(c => c.id === item.type)?.label ? constructIds.find(c => c.id === item.type)?.label : `${item.type}-Handler`}) </li>
                        )}
                    </ol>

                    <Fragment>
                        <Typography> Are you sure you want to update Event ?  </Typography>
                    </Fragment>

                </Grid>

                <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }} >
                    <UpdateCancel onUpdate={onCompletion} onCancel={handleClose} typesNotIn={['transaction', 'view']} />
                </Grid>

            </Box>

        </Dialog >
    )
}

export default UpdateEventAlert;